import {TweenLite} from 'gsap';
const AudioChannel = require('../../viscomjs/audio/AudioChannel');
const MediaAutoplaySupport = require('../../viscomjs/utils/MediaAutoplaySupport');
const control = require('./soundControl');



const autoplayPermission = MediaAutoplaySupport.isAllowed;


const sound = {

};
let _mute = !autoplayPermission;
let _started = false;

const channelPreload = new AudioChannel('preload', {
    loop: true,
    defaultMuted: _mute,
    src: [
        {src: './audio/audio2.ogg', type: 'audio/ogg'},
        {src: './audio/audio2.mp3', type: 'audio/mpeg'}
    ]
});
const channel = new AudioChannel('main', {
    loop: true,
    defaultMuted: _mute,
    src: [
        {src: './audio/verschagin_music.ogg', type: 'audio/ogg'},
        {src: './audio/verschagin_music.mp3', type: 'audio/mpeg'}
    ]
});

control.on('toggleMuteRequest', () => {
    _mute = !_mute;
    if (_mute) {
        channel.mute();
        control.mute();
        return;
    }

    if (!_started) {
        sound.start();
    }

    channel.unmute();
    control.unmute();
});

if (_mute)
    control.mute();
else
    control.unmute();




if (autoplayPermission)
    channelPreload.start();


sound.start = () => {
    if (autoplayPermission) {
        TweenLite.to(channelPreload, 0.3, {
            volume: 0, onComplete: () => {
                channelPreload.stop();
            }
        });
    }

    if (!_mute) {
        _started = true;
        channel.start();
    }
};

module.exports = sound;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/sound/sound.js